import { render, staticRenderFns } from "./TelegramEdit.vue?vue&type=template&id=f0d48560&scoped=true&"
import script from "./TelegramEdit.vue?vue&type=script&lang=js&"
export * from "./TelegramEdit.vue?vue&type=script&lang=js&"
import style0 from "./TelegramEdit.vue?vue&type=style&index=0&id=f0d48560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d48560",
  null
  
)

export default component.exports